<template>
  <div class="gb register-wrapper">
    <v-container class="fill-width" fluid>
      <v-row align="center" justify="center">
        <v-card :loading="status === 'loading'"
                class="fill-width card-theme card-content custom-p-vendor-signup register_vendor custom-container signup-form-container">
          <v-row align="center">
            <v-col cols="12" sm="5" class="pl-7" style="padding-top: 21px;">
              <h2
                  class="azul f-30 title_register"
                  style="margin-top: 0.75rem; margin-bottom: 1rem"
              >Vendor Sign Up</h2>
              <p class="title-suggestion">
                Already have an account?
                <router-link to="/login" class="ml-1 link_register">Login</router-link>
              </p>
            </v-col>
            <v-col cols="12" md="7" sm="7">
            </v-col>
          </v-row>
          <v-divider class="signup-divider" style="margin-left: 0px !important;margin-bottom: 10px !important;"></v-divider>
          <v-alert
              dense
              text
              type="error"
              v-if="invalid_link"
              class="invalid-link__vendor"
          >Invalid link
          </v-alert>
          <div>
            <v-alert
                :value="true"
                color="#19A99D"
                style="color: white;  border-radius: 1rem;margin-left: 15px;margin-bottom: 0px;"
                class="alert-login-vendor"
            >
              <strong>
                <h3>Congratulations!!</h3>
              </strong>
              <p>
                <strong style="font-size: 18px">{{ vendor_company_name }}</strong> has invited you to participate as a
                preferred vendor on
                <strong style="font-size: 18px">Kiey</strong>
              </p>
            </v-alert>
            <div class="expansion-vendor-signup">
              <v-expansion-panels v-model="panel" flat>
                <v-expansion-panel class="mx-span">
                  <v-expansion-panel-header>
                    <strong style="margin: 1rem 1.5rem 0 -0.4rem; font-size: 22px">
                      WHY
                      KIEY?
                    </strong>
                    <template v-slot:actions>
                      <img
                          :src="require('@/assets/img/dropdown-arrow-dark.svg')"
                          alt
                          style="position: relative;top: 8px;left: 5px;transition: all ease 0.5s;"
                      />
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="padding-top: 1rem">
                    <p class="p-expansion-login">
                      Kiey is an application built to easily connect you with
                      new homeowners and referrals from
                      <span
                          style="text-transform: uppercase;"
                      >{{ vendor_company_name }}</span>.
                    </p>
                    <p class="p-expansion-login">
                      Your invite to join means
                      consumers see you as the
                      preferred option in a service area that its customers need
                      and use often.
                    </p>
                    <p class="p-expansion-login">
                      Using Kiey allows you to instantly receive and
                      communicate with new prospects and the agents who are
                      referring you business.
                    </p>

                    <a href="#" @click="showModal">
                      <p class="p-expansion-login war_line">WATCH VIDEO</p>
                    </a>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <br/>
            <v-divider class="hr_epe signup-divider"></v-divider>
            <v-card-title style="padding: 3px 0 0.3rem 1.4rem">
              <span>
                <strong style="font-size: 22px">Account Information</strong>
              </span>
            </v-card-title>
          </div>
          <v-form>
            <ValidationObserver ref="validator" v-slot="{}">
              <div class="pl-6 pr-6 pt-rgister remove-paddings">
                <v-row align="center">
                  <v-col cols="12" sm="4">
                    <div>
                      <ValidationProvider rules="required" ref="first_name" v-slot="{ errors }">
                        <v-text-field
                            v-model="first_name"
                            :error-messages="errors"
                            class="ui-label change_bord especial_border support-input custom-input-position-text sing_up"
                            label="First Name"
                            name="firstName"
                            type="text"
                            width="660px"
                            autocapitalize="words"
                            autocorrect="off"
                            spellcheck="false"
                        ></v-text-field>
                      </ValidationProvider>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" class="pl-35">
                    <div>
                      <ValidationProvider rules="required" ref="last_name" v-slot="{ errors }">
                        <v-text-field
                            v-model="last_name"
                            :error-messages="errors"
                            class="ui-label change_bord especial_border support-input custom-input-position-text sing_up"
                            label="Last Name"
                            name="lastName"
                            type="text"
                            width="660px"
                        ></v-text-field>
                      </ValidationProvider>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" class="pl-54">
                    <div>
                      <ValidationProvider ref="company_name" rules="required" v-slot="{ errors }">
                        <v-text-field
                            v-model="company_name"
                            :error-messages="errors"
                            class="ui-label change_bord especial_border support-input custom-input-position-text sing_up"
                            label="Company Name"
                            name="companyName"
                            type="text"
                            width="660px"
                        ></v-text-field>
                      </ValidationProvider>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="pt-0">
                    <div>
                      <ValidationProvider
                          ref="phone_number"
                          rules="required|size:10"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            v-model="phone_number"
                            :error-messages="errors"
                            :key="isIOS ? 'ios-phone' : 'default-phone'"
                            v-bind="phoneAttrs"
                            class="ui-label change_bord especial_border support-input custom-input-position-text sing_up"
                            label="Username (Cell Phone Number)"
                            name="phone_number"
                            width="660px"
                            :placeholder="isIOS ? '1234567890' : 'xxx - xxx - xxxx'"
                            @input="formatPhoneNumber"
                        ></v-text-field>
                      </ValidationProvider>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="pl-35 pt-0">
                    <div>
                      <ValidationProvider ref="email" rules="required|email" v-slot="{ errors }">
                        <v-text-field
                            v-model="email"
                            :error-messages="errors"
                            class="ui-label change_bord especial_border support-input custom-input-position-text sing_up"
                            label="Email"
                            name="email"
                            type="email"
                            inputmode="email"
                            autocapitalize="none"
                            autocorrect="off"
                            spellcheck="false"
                            width="660px"
                            :style="isIOS ? 'font-size: 16px !important;' : ''"
                        ></v-text-field>
                      </ValidationProvider>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4" class="pl-54 pt-0 service-col">
                    <span class="group pa-2" v-if="service !== ''">
                      <ValidationProvider
                          ref="service"
                          mode="lazy"
                          rules="required"
                          v-slot="{ errors }"
                      >
                        <v-select
                            :error-messages="errors"
                            :items="services"
                            item-text="text"
                            class="ui-label change-whitd change_bord especial_border support-input custom-input-position-text sing_up service-field"
                            v-model="service"
                            :menu-props="{ maxHeight: 300 }"
                        >
                          <template v-slot:label>
                            <span>Service</span>
                            <v-tooltip top max-width="300">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    style="color: #29abe2; font-size: 16px; margin-left: 4px; vertical-align: middle;"
                                >info</v-icon>
                              </template>
                              <span>To suggest a new category, email: Support@kiey.com</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:append>
                            <img
                                :src="require('@/assets/img/dropdown-blue.svg')"
                                class="arrow-year service-arrow"
                                alt
                            />
                          </template>
                        </v-select>
                      </ValidationProvider>
                    </span>
                    <span v-if="service === ''" class="group pa-2">
                      <ValidationProvider ref="other" rules="required" v-slot="{ errors }">
                        <v-text-field
                            v-model="service_other"
                            :error-messages="errors"
                            name="other"
                            type="text"
                            placeholder="Other"
                            required
                            class="ui-label change-whitd change_bord especial_border support-input custom-input-position-text sing_up service-field"
                        >
                          <template v-slot:label>
                            <span>Service</span>
                            <v-tooltip top max-width="300">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    style="color: #29abe2; font-size: 16px; margin-left: 4px; vertical-align: middle;"
                                >info</v-icon>
                              </template>
                              <span>To suggest a new category, email: Support@kiey.com</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:append>
                            <v-icon class="close-other-option" @click="resetService">close</v-icon>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </span>
                  </v-col>
                </v-row>
                <consent-checkboxes
                    :sms-consent.sync="sms_consent"
                    :email-consent.sync="email_consent"
                />
              </div>
            </ValidationObserver>
          </v-form>
          <v-card-text class>
            <div class="p-4 mt-7">
              <div class="text-center">
                <v-btn
                    depressed
                    rounded
                    class="ml-2 mt-2 btn-azul btn_nex cont_btn"
                    height="48px"
                    @click="submit()"
                >
                  SIGN UP
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-row>
      <video-modal :show="showVideoModal" :hide="hideVideoModal"/>
    </v-container>
    <congratulations-modal :show="showCongratulationsModal" :hide="hideModal"/>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import videoModal from "./modals/video";
import config from "@/config/constants.js";
import CongratulationsModal from "./modals/congratulations";
import ConsentCheckboxes from "@/components/forms/ConsentCheckboxes";

export default {
  name: "SignUpVendor",

  async created() {
    try {
      if (this.$store.getters["Authenticate/isLoggedIn"]) {
        await this.$store.dispatch("Authenticate/safety_logout");
        await this.$store.dispatch("Banner/hide");
      }

      await this.$store.dispatch("Owner_sign_up_add_vendors/get_services");

      this.initFromUser();
      this.getNameOwner();

      // ? Inicializar fixes para iOS
      if (this.isIOS) {
        this.setupIOSFixes();
      }
    } catch (e) {
      console.error("SignUpVendor init error:", e);
      this.invalid_link = true;
    }
  },

  directives: {
    mask,
  },

  // ? mounted ya no se usa para lgica crtica
  mounted() {},

  computed: {
    ...mapState({
      services: (state) => state.Owner_sign_up_add_vendors.services,
      status: (state) => state.Vendor_sign_up.status,
      user_sign_up: (state) => state.Vendor_sign_up.user,
      nameOwner: (state) => state.Vendor_sign_up.name_owner,
      vendor_company_name: (state) => state.Vendor_sign_up.company_name,
      countrySelected: (state) => state.Chat.countrySelected,
    }),
    isIOS() {
      if (typeof navigator === 'undefined') return false;
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
    isSafari() {
      if (typeof navigator === 'undefined') return false;
      const ua = navigator.userAgent.toLowerCase();
      return (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1);
    },

    // Atributos dinmicos para inputs
    phoneAttrs() {
      const baseAttrs = {
        type: 'tel',
        inputmode: 'numeric',
        pattern: '[0-9]*',
        autocapitalize: 'none',
        autocorrect: 'off'
      };

      // Para iOS, agregamos prevencin de zoom
      if (this.isIOS) {
        return {
          ...baseAttrs,
          style: 'font-size: 16px !important;' // Previene zoom automtico
        };
      }

      return baseAttrs;
    },

    // Formato visual del telfono (solo para display)
    formattedPhone() {
      if (!this.phone_number) return '';
      const nums = this.phone_number.replace(/\D/g, '');

      if (this.isIOS) {
        // En iOS mostramos sin guiones para mejor UX
        return nums;
      }

      // En otros navegadores, formato con guiones
      if (nums.length <= 3) return nums;
      if (nums.length <= 6) return `${nums.slice(0, 3)}-${nums.slice(3)}`;
      return `${nums.slice(0, 3)}-${nums.slice(3, 6)}-${nums.slice(6, 10)}`;
    }
  },

  data: () => ({
    addressEnabled: false,
    showVideoModal: false,
    panel: [0],
    mask: "### - ### - ####",
    first_name: "",
    last_name: "",
    company_name: "",
    phone_number: "",
    email: "",
    service: null,
    service_other: "",
    address: "",
    addressGoogle: "",
    invalid_link: false,
    sms_consent: false,
    email_consent: false,
    lat: null,
    lng: null,
    showCongratulationsModal: false,
  }),

  props: {},
  watch: {
    phone_number(newVal) {
      // Implementacin manual para mejor compatibilidad iOS
      const nums = newVal.replace(/\D/g, '');
      if (nums.length <= 10) {
        this.phone_number = nums;
      }
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    "video-modal": videoModal,
    CongratulationsModal,
    ConsentCheckboxes,
  },

  methods: {
    formatPhoneNumber() {
      // Guarda la posicin del cursor
      const input = event?.target || null;
      let cursorPos = input ? input.selectionStart : 0;

      // Limpia todos los caracteres no numricos
      let cleanValue = this.phone_number.replace(/\D/g, '');

      // Limita a 10 dgitos
      if (cleanValue.length > 10) {
        cleanValue = cleanValue.slice(0, 10);
      }

      // Actualiza el modelo
      this.phone_number = cleanValue;

      // Para iOS, no aplicamos formato visual con guiones
      if (!this.isIOS && input) {
        // Aplica formato con guiones
        let formatted = cleanValue;
        if (cleanValue.length > 6) {
          formatted = `${cleanValue.slice(0, 3)}-${cleanValue.slice(3, 6)}-${cleanValue.slice(6, 10)}`;
        } else if (cleanValue.length > 3) {
          formatted = `${cleanValue.slice(0, 3)}-${cleanValue.slice(3)}`;
        }

        this.phone_number = formatted;

        // Ajusta la posicin del cursor
        const diff = formatted.length - this.phone_number.length;
        cursorPos = Math.max(0, cursorPos + diff);

        // Restaura la posicin del cursor despus de la actualizacin del DOM
        this.$nextTick(() => {
          if (input) {
            input.setSelectionRange(cursorPos, cursorPos);
          }
        });
      }
    },

    // Mtodo para obtener el telfono limpio para enviar
    getCleanPhoneNumber() {
      return this.phone_number.replace(/\D/g, '');
    },
    initFromUser() {
      if (!this.user_sign_up.phone_number) return;

      const service_exists = this.services.find(
          (o) => o.value === this.user_sign_up.service
      );

      this.first_name = this.user_sign_up.first_name;
      this.last_name = this.user_sign_up.last_name;
      this.company_name = this.user_sign_up.company_name;

      // Manejo especial para telfono en iOS
      let phone = this.user_sign_up.phone_number.replace(
          config.phone_extension,
          ""
      );

      // Para iOS, mantenemos solo nmeros sin formato
      if (this.isIOS) {
        this.phone_number = phone.replace(/\D/g, '');
      } else {
        // Para otros navegadores, aplicamos formato
        this.phone_number = phone;
      }

      this.email = this.user_sign_up.email;
      this.address = this.user_sign_up.address;
      this.addressGoogle = this.user_sign_up.addressGoogle;
      this.service = service_exists ? this.user_sign_up.service : "";
      this.service_other = service_exists ? "" : this.user_sign_up.service;
    },

    hideModal() {
      this.showCongratulationsModal = false;
    },

    showModal() {
      this.showVideoModal = true;
    },

    hideVideoModal() {
      this.showVideoModal = false;
    },

    resetService() {
      this.service = this.services[0];
      this.service_other = "";
    },

    async submit() {
      const valid = await this.$refs.validator.validate();

      if (!valid) return;
      if (!this.sms_consent || !this.email_consent) return;

      // let phone = this.phone_number;
      let phone = this.getCleanPhoneNumber();

      if (phone.length !== 10) {
        this.$refs.phone_number.setErrors(['Phone number must be 10 digits']);
        return;
      }

      // ? Safari safe
      // phone = phone.replace(/[\s-]/g, "");
      // phone = config.phone_extension + phone;
      phone = config.phone_extension + phone;

      this.$store
          .dispatch("Vendor_sign_up/signup_vendor", {
            first_name: this.first_name,
            last_name: this.last_name,
            company_name: this.company_name,
            service: this.service ? this.service : this.service_other,
            phone_number: phone,
            email: this.email,
            address: this.address,
            addressGoogle: this.addressGoogle,
            sms_consent: this.sms_consent,
            email_consent: this.email_consent,
            sms_consent_url: window.location.href,
          })
          .then(() => {
            this.showCongratulationsModal = true;
          })
          .catch((error) => {
            this.$refs.phone_number.setErrors([error]);
          });
    },

    getNameOwner() {
      const token =
          this.$route.params.referral ||
          this.$route.query.referral;

      if (!token) {
        this.invalid_link = true;
        return;
      }

      this.$store
          .dispatch("Vendor_sign_up/add_name_owner", token)
          .then((response) => {
            if (response?.data?.code === "ERROR") {
              this.invalid_link = true;
              return;
            }

            const r_user = response.data.user;

            if (r_user.service) {
              const service_exists = this.services.find(
                  (o) => o.value === r_user.service
              );
              this.service = service_exists ? r_user.service : "";
              this.service_other = service_exists ? "" : r_user.service;
            }

            this.first_name = r_user.first_name;
            this.last_name = r_user.last_name;
            this.company_name = r_user.company_name;
            this.phone_number = r_user.phone_number.replace(
                config.phone_extension,
                ""
            );
            this.email = r_user.email;
            this.address = r_user.address;
          })
          .catch(() => {
            this.invalid_link = true;
          });
    },

    getAddressData(addressData, placeResultData) {
      this.addressGoogle = {
        city: addressData.locality,
        country: "US",
        line1: placeResultData.formatted_address,
        postal_code: addressData.postal_code,
        state: addressData.administrative_area_level_1,
      };

      this.address = placeResultData.formatted_address;
    },
    setupIOSFixes() {
      // Previene el zoom automtico en iOS
      document.querySelectorAll('input, select, textarea').forEach(el => {
        el.addEventListener('focus', function() {
          window.setTimeout(() => {
            const scrollY = window.pageYOffset;
            window.scrollTo(0, Math.max(scrollY - 100, 0));
          }, 0);
        });
      });

      // Mejora el rendimiento de animaciones
      if (typeof document !== 'undefined') {
        document.body.style.webkitBackfaceVisibility = 'hidden';
      }
    }
  },
};
</script>


<style scoped>
  .register-wrapper {
    display: block;
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
  }

  .cont_btn span {
    color: #ffffff;
    font-size: 15px !important;
    font-weight: 700 !important;
    letter-spacing: 0.94px !important;
    text-transform: uppercase;
  }

  .hr_epe {
    margin-top: -33px;
    margin-bottom: 32px;
    position: relative;
    z-index: 20;
  }

  .pt-rgister {
    padding-top: 22px !important;
  }

  .link_register {
    color: #3256a4;
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
  }

  .title_register {
    color: #041332;
    font-size: 30px;
    font-weight: 500;
    line-height: 34px;
    font-family: "Roboto-Medium";
  }

  .btn_nex {
    font-size: 15px;
    font-weight: 700;
    -webkit-appearance: none;
    appearance: none;
  }

  .service-arrow {
    position: relative;
    top: 13px;
  }

  .pl-35 {
    padding-left: 35px;
  }

  .pl-54 {
    padding-left: 54px;
  }

  .custom-p-vendor-signup {
    padding: 20px 103px 59px 91px !important;
  }

  .register_vendor {
    max-width: 1181px !important;
    width: 100% !important;
  }

  .summary-label {
    color: #061d47;
    font-size: 15.5px;
    margin-top: 1rem;
  }

  .alert-login-vendor h3 {
    font-size: 22px;
    margin: 3px 0px 0.24rem 17px;
  }

  .alert-login-vendor p {
    font-size: 18px;
    margin: 8px 0 7px 16px;
    letter-spacing: -0.35px;
    font-weight: 400;
  }

  .summary-value {
    color: #3c5fa9;
    font-size: 18px;
  }

  .p-expansion-login {
    margin-left: 1.5rem;
    font-size: 18px;
    color: #2d2d2d;
    font-weight: 400;
    letter-spacing: -0.35px;
    line-height: 27px;
  }

  .war_line {
    font-family: "Roboto-Medium";
    font-weight: 500 !important;
  }

  .padding-payment-inputs {
    padding-bottom: 0.2rem;
  }

  .link-check {
    color: #29abe2;
    text-decoration: none;
  }

  .ml-14 {
    margin-left: 56px;
  }

  .ml-16 {
    margin-left: 64px;
  }

  .account-information-checkbox {
    position: static;
    right: auto;
    top: auto;
  }

  .alert-value-font {
    font-size: 18px;
  }

  .small-checkbox >>> label {
    font-size: 14px;
  }

  @media (max-width: 960px) {
    .custom-p-vendor-signup {
      padding: 15px !important;
    }

    .alert-login-vendor h3 {
      font-size: 16px;
    }

    .alert-login-vendor p {
      font-size: 13px;
    }

    .p-expansion-login {
      margin-left: auto;
      font-size: 12px;
    }

    .ml-14 {
      margin-left: auto;
    }

    .ml-16 {
      margin-left: auto;
    }

    .pl-35 {
      padding-left: 0;
    }

    .pl-54 {
      padding-left: 0;
    }
  }

  @media (max-width: 1100px) {
    .custom-p-vendor-signup {
      padding: 20px 40px !important;
    }

    .pl-35 {
      padding-left: 15px;
    }

    .pl-54 {
      padding-left: 25px;
    }
  }

  @media (max-width: 1400px) {
    .account-information-checkbox {
      position: static;
      right: auto;
      top: auto;
    }
  }

  @media (max-width: 600px) {
    .title_register {
      font-size: 25px;
    }

    .custom-p-vendor-signup {
      padding: 10px !important;
    }

    .register_vendor {
      max-width: 100% !important;
    }

    .register-wrapper {
      min-height: auto;
    }

    .service-col {
      padding-bottom: 48px !important;
    }

    .service-arrow {
      top: 0px !important;
    }
  }

  /* iOS Specific Fixes */
  @supports (-webkit-touch-callout: none) {
    .register-wrapper {
      width: 100%;
      min-height: 100vh;
      display: block;
    }

    .register_vendor {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 auto;
    }

    .custom-p-vendor-signup {
      padding: 15px !important;
    }

    v-text-field,
    .v-text-field,
    input,
    textarea,
    select {
      font-size: 16px !important;
      -webkit-appearance: none !important;
      appearance: none !important;
      border-radius: 4px;
    }

    button,
    .v-btn {
      -webkit-appearance: none !important;
      appearance: none !important;
      font-size: 16px !important;
    }

    .pl-35 {
      padding-left: 0 !important;
    }

    .pl-54 {
      padding-left: 0 !important;
    }

    .pl-6 {
      padding-left: 0 !important;
    }

    .pr-6 {
      padding-right: 0 !important;
    }
  }
  /* Agrega esto a tu seccin de estilos */
  @supports (-webkit-touch-callout: none) {
    /* iOS-specific styles */

    /* Solucin para input zoom en iOS */
    @media screen and (max-width: 768px) {
      input,
      select,
      textarea {
        font-size: 16px !important;
      }
    }

    /* Evita el resaltado azul en tap */
    .v-btn,
    button,
    a {
      -webkit-tap-highlight-color: transparent;
    }

    /* Mejora el scrolling */
    .register-wrapper {
      -webkit-overflow-scrolling: touch;
    }

    /* Soluciona problemas de posicin fixed */
    .v-dialog {
      position: absolute !important;
    }

    /* Inputs ms altos para mejor UX */
    .sing_up .v-input__control {
      min-height: 56px !important;
    }

    /* Evita zoom automtico en focus */
    .sing_up input {
      transform: scale(1);
      transform-origin: left top;
    }
  }

  /* Solucin para Safari mask */
  @media not all and (min-resolution:.001dpcm) {
    @supports (-webkit-appearance:none) {
      .v-text-field input {
        letter-spacing: 0.5px; /* Ayuda con mscaras en Safari */
      }
    }
  }
  .ios-dialog-fix {
    @supports (-webkit-touch-callout: none) {
      max-height: 80vh !important;
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch !important;
    }
  }
  .btn-azul {
    @supports (-webkit-touch-callout: none) {
      cursor: pointer;
      min-height: 44px !important; /* Tamao mnimo recomendado por Apple */
      padding: 0 16px !important;
    }
  }

  /* Evita el efecto de active azul en iOS */
  .v-btn::after {
    display: none !important;
  }

  @media screen and (-webkit-min-device-pixel-ratio:0) {
    .sing_up .v-input__slot {
      min-height: 44px !important; /* Tamao mnimo tctil recomendado por Apple */
    }

    .sing_up input {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }

    /* Previene el zoom en inputs en iOS < 13 */
    @supports (-webkit-touch-callout: none) {
      .sing_up input[type="text"],
      .sing_up input[type="tel"],
      .sing_up input[type="email"] {
        font-size: 16px !important;
        line-height: 1.5 !important;
      }
    }

    /* Mejora la experiencia tctil en botones */
    .btn-azul {
      min-height: 44px !important;
      padding: 12px 24px !important;
      -webkit-tap-highlight-color: transparent;
    }

    /* Fix para modales en iOS */
    .v-dialog__container {
      -webkit-overflow-scrolling: touch !important;
      overflow-y: auto !important;
    }
  }

  /* Fix para Safari mask en inputs */
  @supports (-webkit-appearance: none) and (stroke-color: transparent) {
    .sing_up input::-webkit-contacts-auto-fill-button {
      visibility: hidden;
      display: none !important;
      pointer-events: none;
      position: absolute;
      right: 0;
    }
  }

  /* Previene el resaltado azul en tap en iOS */
  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
  }
</style>
<style lang="scss" scoped>
  .pt-rgister {
    div {
      div {
        padding-left: 5px !important;
      }
    }
  }

  .alert-login-vendor {
    margin-left: 0 !important;
  }

  .service-field ::v-deep .v-label {
    overflow: visible !important;
    pointer-events: auto !important;
  }
</style>
